<template>
  <ModalDefault
    modal_id="addLeadEstimateModal"
    header="y"
    size="modal-xl modal-dialog-scrollable"
    style_header=""
    :modal_header="
      modalOption === 'intro'
        ? `Selecione uma opção`
        : modalOption === 'priceConsult'
        ? `Consulta de preço`
        : modalOption === 'createQuote'
        ? `Cadastrar nova proposta`
        : `Preview de Proposta`
    "
    :footer="true"
    icon="bx bx-copy-alt mr-1"
  >
    <!-- MODAL INTRO-->
    <div v-if="modalOption === 'intro'" class="text-center" slot="body">
      <button @click="modalOption = 'priceConsult'" class="btn btn-primary">
        <i class="fi fi-rr-search-dollar"></i>

        Consulta de preço
      </button>
      <button @click="modalOption = 'createQuote'" class="btn btn-primary">
        <i class="fi fi-rr-money-check-edit"></i>
        Cadastrar proposta
      </button>
    </div>

    <!-- PRICE CONSULT -->
    <div v-if="modalOption === 'priceConsult'" slot="body">
      <b-input-group prepend="Pesquisar por produto" class="mb-3">
        <b-form-input
          v-model="search"
          v-on:keyup.enter="searchProducts()"
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-success" v-on:click="searchProducts()"
            >Pesquisar</b-button
          >
        </b-input-group-append>
      </b-input-group>

      <div v-if="products.pagination && products.pagination.total === 0">
        <span style="color: red">Produto não encontrado.</span>
      </div>
      <div
        style=""
        cols="12"
        v-if="
          products.pagination &&
          products.pagination.total &&
          products.pagination.total > 0
        "
      >
        <b-table
          :fields="fields0"
          :items="products.pagination.data"
          head-variant="light"
          striped
          hover
          sticky-header="300px"
          style="
            width: 100% !important;
            height: 100% !important;
            background: white;
          "
        >
          <!--ID -->
          <template #cell(index)="data">
            {{ data.item.internal_code }}
          </template>

          <!-- NAME -->
          <template #cell(name)="data">
            {{ data.item.name }}
          </template>

          <!-- CATEGORY -->
          <template #cell(category)="data">
            {{
              data.item.category && data.item.category.name
                ? data.item.category.name
                : "---"
            }}
          </template>

          <!-- BRAND -->
          <template #cell(brand)="data">
            {{
              data.item.brand && data.item.brand.name
                ? data.item.brand.name
                : "---"
            }}
          </template>

          <!-- SUPPLIER -->
          <template #cell(supplier)="data">
            {{
              data.item.supplier && data.item.supplier.name
                ? data.item.supplier.name
                : "---"
            }}
          </template>

          <!-- PRICE -->
          <template #cell(price)="data">
            {{ priceFormat(data.item.price) }}
          </template>

          <!-- AMMOUNT -->
          <template #cell(amount)="data">
            {{ data.item.amount }}
          </template>
        </b-table>
      </div>
    </div>

    <!-- CREATE QUOTE -->
    <div v-if="modalOption === 'createQuote'" class="px-2 py-0" slot="body">
      <div style="max-height: 700px; min-height: 480px">
        <div class="row">
          <div class="col-12 p-2">
            <b-input-group class="mb-3">
              <b-form-input
                placeholder="Pesquisar produto"
                class="search-field"
                v-model="search"
                v-on:keyup.enter="searchProducts()"
              ></b-form-input>
              <b-input-group-append style="padding-left:15px;">
                <b-button 
                  v-on:click="clearQuote()"
                  class="quote-button"
                >
                  Limpar
                </b-button>
                <b-button
                  style="margin-left:15px;"
                  class="quote-button"
                  :class="(modalOption === 'createQuote' && canSave) ? `visible`:`invisible`"
                  @click.prevent="validateFields"
                >
                  Salvar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
        <div class="row">
          <div
            class="col-12"
            v-if="products.pagination && products.pagination.total === 0"
          >
            <span style="color: red">Produto não encontrado.</span>
          </div>
          <div
            class="col-12 product-list"
            style=""
            v-if="
              products.pagination &&
              products.pagination.total &&
              products.pagination.total > 0
            "
          >
            <b-table
              :fields="fields"
              :items="products.pagination.data"
              head-variant="light"
              striped
              hover
              sticky-header="250px"
              style="
                width: 100% !important;
                height: 100% !important;
                background: white;
              "
            >
              <!--ID -->
              <template #cell(index)="data">
                {{ data.item.internal_code }}
              </template>

              <!-- NAME -->
              <template #cell(name)="data">
                {{ data.item.name }}
              </template>

              <!-- CATEGORY -->
              <template #cell(category)="data">
                {{
                  data.item.category && data.item.category.name
                    ? data.item.category.name
                    : "---"
                }}
              </template>

              <!-- BRAND -->
              <template #cell(brand)="data">
                {{
                  data.item.brand && data.item.brand.name
                    ? data.item.brand.name
                    : "---"
                }}
              </template>

              <!-- SUPPLIER -->
              <template #cell(supplier)="data">
                {{
                  data.item.supplier && data.item.supplier.name
                    ? data.item.supplier.name
                    : "---"
                }}
              </template>

              <!-- PRICE -->
              <template #cell(price)="data">
                {{ priceFormat(data.item.price) }}
              </template>

              <!-- AMMOUNT -->
              <template #cell(amount)="data">
                {{ data.item.amount }}
              </template>
              <!-- DISCOUNT -->
              <template #cell(discount)="data">
                {{ data.item.max_discount ? data.item.max_discount : 0 }}%
              </template>

              <!-- ACTIONS -->
              <template #cell(actions)="data">
                <b-button
                  v-on:click="addProductToQuote(data.item)"
                  variant="outline-primary"
                  style="height:30px;"
                >
                  <i class="bx bx-plus" style="font-size: 16px"></i>
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
        <div class="row">
          <div class="col-8" v-if="quoted_products.length > 0">
            <b-table
              id="quotedProductsTable"
              :fields="fields2"
              :items="quoted_products"
              head-variant="light"
              striped
              hover
              sticky-header="150px"
              style="
                width: 100% !important;
                height: 100% !important;
                background: white;
              "
            >
              <!-- PRICE -->
              <template #cell(price)="data">
                {{ priceFormat(data.item.price) }}
              </template>
              <template #cell(quoted_amount)="data">
                <input
                  type="number"
                  @keydown="
                    (e) => {
                      calculateQuotedAmount(e, data.index, data.item);
                    }
                  "
                  @keyup="
                    (e) => {
                      calculateQuotedAmount(e, data.index, data.item);
                    }
                  "
                  @click="
                    (e) => {
                      calculateQuotedAmount(e, data.index, data.item);
                    }
                  "
                  @mouseup="
                    (e) => {
                      calculateQuotedAmount(e, data.index, data.item);
                    }
                  "
                  style="width: 100px"
                  class="inputStyle"
                  :value="data.item.quoted_amount"
                />
              </template>
              <template #cell(discount)="data">
                <input
                  type="number"
                  @keydown="
                    (e) => {
                      validateDiscount(e, data.index, data.item);
                    }
                  "
                  @keyup="
                    (e) => {
                      validateDiscount(e, data.index, data.item);
                    }
                  "
                  @click="
                    (e) => {
                      validateDiscount(e, data.index, data.item);
                    }
                  "
                  style="width: 100px"
                  class="inputStyle"
                  :value="data.item.discount"
                />%
              </template>
              <template #cell(total)="data">
                <div :id="`quotedTotal${data.index}`"></div>
              </template>
            </b-table>
          </div>
          <div class="col-4" v-if="quoted_products.length > 0">
            <div>
              <label>
                Valor total:
                <input type="text" class="inputStyle" id="totalPrice" readonly />
              </label>
            </div>
            <div>
              <label>
                Data de Vencimento:
                <input
                  onclick="this.showPicker()"
                  type="date"
                  required
                  class="inputStyle"
                  v-model="lead_quotes.current_lead_quote.expiration_at"
                />
              </label>

              <span
                v-if="fields_with_error.expiration_at"
                class="text-danger pl-1"
                >{{ fields_with_error.expiration_at }}</span
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12" v-if="quoted_products.length > 0">
            <label> Descrição: </label>
            <textarea
              v-model="lead_quotes.current_lead_quote.description"
              style="height: 100px; width: 100%"
              class="inputStyle"
            ></textarea>
            <span class="float-right"
              ><a
                href="javascript:;"
                @click="lead_quotes.current_lead_quote.description = ''"
                >Limpar</a
              ></span
            >

            <span v-if="fields_with_error.description" class="text-danger pl-1">{{
              fields_with_error.description
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- QUOTE SAVED -->
    <div v-if="modalOption === 'quoteSaved'" class="px-2 py-0" slot="body">
      <div
        style="max-height: 700px; min-height: 480px; white-space: pre-line"
        id="previewMessage"
      >
Proposta: {{ lead_quotes.current_lead_quote.id }}

        <div
          v-for="product in lead_quotes.current_lead_quote.products"
          :key="product.id"
        >
{{ product.name }}
Valor Unitário: {{ priceFormat(product.price) }} Quantidade: {{ product.pivot.amount }}
          <span v-if="product.pivot.discount > 0">
Valor com desconto: {{ priceFormat(product.pivot.total) }} ({{ product.pivot.discount ? product.pivot.discount : 0 }}% de desconto)
          </span>
        </div>

        Valor Total: {{ priceFormat(lead_quotes.current_lead_quote.total) }}

        {{ lead_quotes.current_lead_quote.description }}
      </div>
    </div>

    <div slot="footer" class="px-2 py-2 d-flex" v-if="modalOption === 'quoteSaved'">
      <div>
        <span
          v-if="false"
          @click.prevent="
            modalOption = 'intro';
            clearQuote();
          "
          class="shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3"
        >
          <span class="">&lt;&lt; Voltar</span>
        </span>
        <span
          v-if="modalOption === 'quoteSaved'"
          @click.prevent="backToQuote"
          class="btn quote-button"
        >
          <span class="">&lt;&lt; Voltar</span>
        </span>
        <span
          v-if="modalOption === 'quoteSaved' && canShare"
          @click.prevent="shareQuote"
          class="btn quote-button"
        >
          <span class="">Compartilhar</span>
        </span>
        <span
          v-if="false"
          @click.prevent="validateFields"
          class="shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3"
        >
          <span class="">Prosseguir</span>
        </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../general/ModalDefault";
import { mapGetters, mapState } from "vuex";
import $ from "jquery";
import no_pic from "../../assets/img/no-pic.png";
import Swal from "sweetalert2";
import TextCount from "../general/TextCount";
import Pagination from "../theme/Pagination.vue";
import lead_quotes from "../../store/modules/lead_quotes";

export default {
  name: "ModalAddLeadQuote",
  components: {
    TextCount,
    ModalDefault,
    Pagination,
  },
  computed: {
    ...mapState([
      "templates",
      "chat",
      "channels",
      "configs",
      "me",
      "operators",
    ]),

    ...mapGetters(["getChannelObject"]),
  },
  data() {
    return {
      search: "",
      modalOption: "createQuote",
      quoted_products: [],
      quoted_totals: [],
      //codigo, nome, marca, fornecedor, preço, quantidade, ação
      fields0: [
        { key: "index", label: "Codigo", thStyle: { padding: "5px" } },
        { key: "name", label: "Nome", thStyle: { padding: "5px" } },
        { key: "brand", label: "Marca", thStyle: { padding: "5px" } },
        { key: "supplier", label: "Fornecedor", thStyle: { padding: "5px" } },
        { key: "price", label: "Preço", thStyle: { padding: "5px" } },
        { key: "amount", label: "Quantidade", thStyle: { padding: "5px" } },
      ],
      fields: [
        { key: "index", label: "Codigo", thStyle: { padding: "5px" } },
        { key: "name", label: "Nome", thStyle: { padding: "5px" } },
        { key: "brand", label: "Marca", thStyle: { padding: "5px" } },
        { key: "supplier", label: "Fornecedor", thStyle: { padding: "5px" } },
        { key: "price", label: "Preço", thStyle: { padding: "5px" } },
        { key: "amount", label: "Quantidade", thStyle: { padding: "5px" } },
        { key: "actions", label: "Ações", thStyle: { padding: "5px" } },
      ],
      fields2: [
        { key: "name", label: "Nome", thStyle: { padding: "5px" } },
        { key: "price", label: "Preço", thStyle: { padding: "5px" } },
        {
          key: "quoted_amount",
          label: "Quantidade",
          thStyle: { padding: "5px" },
        },
        { key: "discount", label: "Desconto", thStyle: { padding: "5px" } },
        { key: "total", label: "Total", thStyle: { padding: "5px" } },
      ],
      porcentagem: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "%",
        precision: 2,
        masked: false,
      },
      errors_exists: false,
      fields_with_error: {
        expiration_at: null,
        description: null,
      },
      canSave: false,
      canShare: false,
      descriptionModel:
        "Prezado(a) {{NAME}},\n\nAgradecemos por seu interesse em nossos serviços. Segue abaixo a proposta personalizada de acordo com sua solicitação:\n\nFormas de Pagamento:\n\nÀ vista com [5%] de desconto via transferência bancária\nParcelado em até [3x] sem juros no cartão de crédito\nBoleto bancário com vencimento em 30 dias\nEsta proposta é válida até [Data de Validade]. Por favor, não hesite em entrar em contato caso tenha dúvidas ou precise de mais informações.\n\nAtenciosamente,\n\n{{OPERATOR}}",
    };
  },
  computed: {},
  mounted() {
    $("#addLeadEstimateModal").on("show.bs.modal", () => {
      //this.clearQuote();
      if (this.chat.ticket.id !== this.getStoredTicket()) {
        this.clearQuote();
      }
      this.setStoredTicket();
    });
  },
  methods: {
    getStoredTicket() {
      return parseInt(localStorage.getItem("current_ticket_id"));
    },
    setStoredTicket() {
      return localStorage.setItem("current_ticket_id", this.chat.ticket.id);
    },
    shareQuote() {
      this.$store.dispatch("sendMessage", {
        text: $("#previewMessage").text(),
        channel_id: this.chat.ticket.channel_id,
        ticket_id: this.chat.ticket.id,
        operator_id: this.isOperator(this.chat.ticket.department_id),
        department_id: this.chat.ticket.department_id,
      });

      api
        .get(`create-kanban-card/${this.lead_quotes.current_lead_quote.id}`)
        .then((response) => {
        });

      $("#addLeadEstimateModal").modal("hide");
      this.clearQuote();
    },
    clearQuote() {
      this.lead_quotes.current_lead_quote = {
        channel_id: null,
        department_id: null,
        lead_id: null,
        total: null,
        user_id: null,
        expiration_at: null,
        description: null,
      };
      this.quoted_products = [];
      this.quoted_totals = [];
      this.products.pagination = [];
      this.search = "";
      this.modalOption = "createQuote";
      setTimeout(() => {
        this.canSave = false;
      }, 500);
    },
    validateFields() {
      this.errors_exists = false;
      this.fields_with_error.expiration_at = null;
      this.fields_with_error.description = null;

      if (
        ["", null].includes(this.lead_quotes.current_lead_quote.expiration_at)
      ) {
        this.errors_exists = true;
        this.fields_with_error.expiration_at = "Campo obrigatório";
      }
      if (
        ["", null].includes(this.lead_quotes.current_lead_quote.description)
      ) {
        this.errors_exists = true;
        this.fields_with_error.description = "Campo obrigatório";
      }

      if (!this.errors_exists) {
        this.saveLeadQuote();
      } else {

      }
    },
    getTotalPriceFromProducts() {
      if (this.quoted_totals.length >= 1) {
        let total = this.quoted_totals.reduce(
          (acc, currentValue) => acc + currentValue,
          0
        );
        if (total) {
          $("#totalPrice").val(this.priceFormat(total));
        } else {
          $("#totalPrice").val(this.priceFormat(0));
        }
      } else {
        $("#totalPrice").val(this.priceFormat(0));
      }
    },
    getTotalPriceFromQuotedProduct(product_index) {
      return this.quoted_products[product_index].total;
    },
    calculateQuotedAmount(e, index, product) {
      let value = e.target.value;
      if (value <= 0) {
        e.target.value = 0;
      }
      if (value >= product.amount) {
        e.target.value = product.amount;
      }

      let discount = 0;
      this.quoted_products[index].quoted_amount = e.target.value;
      this.quoted_totals[index];
      this.quoted_totals[index] = (product.price - discount) * value;
      $(`#quotedTotal${index}`).html(
        this.priceFormat(this.quoted_totals[index])
      );
      this.getTotalPriceFromProducts();
    },
    validateDiscount(e, index, product) {
      let value = e.target.value;
      if (value <= 0) {
        e.target.value = 0;
      }
      if (value >= product.max_discount) {
        e.target.value = product.max_discount;
      }
      this.quoted_products[index].discount = e.target.value;
      let discount = (product.price / 100) * e.target.value;
      this.quoted_totals[index] =
        (product.price - discount) * this.quoted_products[index].quoted_amount;
      if (this.quoted_totals[index]) {
        $(`#quotedTotal${index}`).html(
          this.priceFormat(this.quoted_totals[index])
        );
      }
      this.getTotalPriceFromProducts();
    },
    priceFormat(price) {
      return Number(price).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },
    addProductToQuote(product) {
      let find = this.quoted_products.find((e, i) => {
        return e.id === product.id;
      });
      if (!find) {
        product.quoted_amount = 0;
        product.discount = 0;
        product.quoted_total = 0;
        this.quoted_products.push(product);
        if (!this.lead_quotes.current_lead_quote.description) {
          this.lead_quotes.current_lead_quote.description =
            this.descriptionModel;
        }
        this.canSave = true;
      } else {

      }
    },
    priceFormat(price) {
      return Number(price).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },
    backToQuote() {
      this.canSave = true;
      this.canShare = false;
      this.modalOption = "createQuote";
      setTimeout(() => {
        $("#quotedProductsTable")
          .find("input")
          .each((i, e) => {
            $(e).trigger("click");
          });
      }, 100);
    },
    async saveLeadQuote() {
      if (this.quoted_totals.length >= 1) {
        let total = this.quoted_totals.reduce(
          (acc, currentValue) => acc + currentValue,
          0
        );

        const getTotal = total ? total : 0;

        const lead_quote = {
          lead_id: this.chat.ticket.lead_id,
          channel_id: this.chat.ticket.channel_id,
          department_id: this.chat.ticket.department_id,
          user_id: this.me.data.id,
          total: getTotal,
          expiration_at: this.lead_quotes.current_lead_quote.expiration_at,
          description: this.lead_quotes.current_lead_quote.description,
          included_products: this.quoted_products.map((e, i) => {
            let quoted_total = this.quoted_totals[i];
            return {
              product_id: e.id,
              amount: e.quoted_amount,
              discount: e.discount,
              total: quoted_total,
            };
          }),
        };

        if (this.lead_quotes.current_lead_quote.id) {
          lead_quote.id = this.lead_quotes.current_lead_quote.id;
          await this.$store.dispatch("updateLeadQuote", lead_quote);
        } else {
          await this.$store.dispatch("createLeadQuote", lead_quote);
        }
        this.modalOption = "quoteSaved";
        setTimeout(() => {
          this.canShare = true;
        }, 1000);
      }
    },
    async searchProducts() {
      await this.$store.dispatch("getAllProducts", {
        q: this.search,
        channel_id: this.chat.ticket.channel_id,
        department_id: this.chat.ticket.department_id,
        status_key: 1,
      });
      // await api
      //   .get("/products", {
      //     params: {
      //       q: this.search,
      //       channel_id: 1,
      //       department_id: 1,
      //     },
      //   })
      //   .then((response) => {
      //   });
    },

    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject("id", this.chat.ticket.channel_id)
          .parameter.department_id;
      }
      let operator = this.operators.data.find((operator) => {
        return (
          operator.department_id === department_id &&
          operator.user_id === this.me.data.id
        );
      });
      if (operator !== undefined) {
        return operator.id;
      } else {
        return null;
      }
    },
    clear() {},
  },
};
</script>

<style scoped>
.search-field.form-control {
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  border: 1px solid gray !important;
  font-size: larger !important;
}
.quote-button {
  border-radius:5px !important;
  background-color:#192730 !important;
  color:white !important;
  font-size: larger !important;
}
.modal-dialog-scrollable .modal-body {
}
.inputStyle {
  width: 300px;
  height: 37.19px;
  border: 1px solid rgb(156 163 175 / 0.55);

  outline: none;
  background-color: white;
  color: #858796;
  font-size: 14px;
  @apply p-2;
}
.inputStyle:focus {
  border: 1px solid #919191;
}
</style>
